import { render } from "./CustomClassHandler.vue?vue&type=template&id=644ac17e"
import script from "./CustomClassHandler.vue?vue&type=script&lang=js"
export * from "./CustomClassHandler.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/html/miw-alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__